import { registerBrowserObservability } from './utils/browserObservability';

// Next runs this file in the browser before any page code, for the App Router
// and the legacy pages/ tree alike. It is the browser half of the catalog
// publisher registration (the server half is instrumentation.ts).
registerBrowserObservability();
